<style lang="stylus">
    .OrgChartOutput-mask
        modal-mask()
        .OrgChartOutput-modal
            // width 690px
            height 485px
            .OrgChartOutput-container
                padding 15px 20px
                .OrgChartOutput-topbox
                    width 660px
                    height 200px
                    .OrgChartOutput-optionbox
                        float left
                        width 260px
                        height 200px
                        .OrgChartOutput-optionbox-title
                            font-size 14px
                            color #333
                            margin-bottom 5px
                        ul
                            list-style none
                            width 260px
                            height 173px
                            border 1px solid var(--border-color-orgchartoutput-ul)
                            border-radius 3px
                            overflow-y auto
                            li
                                padding 5px 0 5px 5px
                                &:hover
                                    background-color $right-view-content-hovercolor
                            li.active
                                background-color var(--bg-color-orgchartoutput-li-active)
                    .OrgChartOutput-menubox
                        float left
                        position relative
                        width 140px
                        height 200px
                        .OrgChartOutput-menubtn
                            margin 0 auto
                            width 100px
                            height 24px
                            border 1px solid var(--border-color-orgchartoutput-ul)
                            border-radius 3px
                            line-height 24px
                            font-size 12px
                            text-align center
                            user-select none
                            cursor pointer
                            overflow hidden
                            text-overflow ellipsis
                            padding 0 10px
                            white-space nowrap
                            margin-bottom 10px
                            &:first-child
                                margin-top 26px
                            &:nth-child(3n)
                                margin-top 57px
                            &:last-child
                                margin-bottom 0
                            &:hover
                                background-color $box-bordercolor-lignt
                .OrgChartOutput-bottombox
                    width 660px
                    height 100px
                    margin-top 50px
                    border 1px solid var(--border-color-orgchartoutput-ul)
                    border-radius 3px
                    .OrgChartOutput-optionLine
                        margin 20px 0 0 40px
                        .ivu-checkbox
                            &:not(.ivu-checkbox-checked):not(.ivu-checkbox-disabled)
                                .ivu-checkbox-inner
                                    background-color var(--bg-color-tertiary)
                        .optionLine-title
                            padding-right 40px
</style>

<template>
    <div class="OrgChartOutput-mask">
        <Dialog class="OrgChartOutput-modal" :title="$t('OrgChartOutput.title')" :isShow="true" @close="closeModal">
            <div class="OrgChartOutput-container">
                <div class="OrgChartOutput-topbox">
                    <div class="OrgChartOutput-optionbox OrgChartOutput-leftbox">
                        <p class="OrgChartOutput-optionbox-title">{{ $t("OrgChartOutput.canOutputObject") }}</p>
                        <ul>
                            <li :class="{ active: leftID == item.id }" v-for="item in leftList" :key="item.id" @click="selectLeft(item.id)">
                                {{ item.name }}
                            </li>
                        </ul>
                    </div>
                    <div class="OrgChartOutput-menubox">
                        <div class="OrgChartOutput-menubtn" @click="addToRight()" :title="$t('OrgChartOutput.addToRight')">
                            {{ $t("OrgChartOutput.addToRight") }}>
                        </div>
                        <div class="OrgChartOutput-menubtn" @click="addToLeft()" :title="$t('OrgChartOutput.addToLeft')">
                            <{{ $t("OrgChartOutput.addToLeft") }}
                        </div>
                        <div class="OrgChartOutput-menubtn" @click="allRight()" :title="$t('OrgChartOutput.allRight')">
                            {{ $t("OrgChartOutput.allRight") }}>>
                        </div>
                        <div class="OrgChartOutput-menubtn" @click="allLeft()" :title="$t('OrgChartOutput.allLeft')">
                            <<{{ $t("OrgChartOutput.allLeft") }}
                        </div>
                    </div>
                    <div class="OrgChartOutput-optionbox OrgChartOutput-rightbox">
                        <p class="OrgChartOutput-optionbox-title">{{ $t("OrgChartOutput.outputObject") }}</p>
                        <ul>
                            <li :class="{ active: rightID == item.id }" v-for="item in rightList" :key="item.id" @click="selectRight(item.id)">
                                {{ item.name }}
                            </li>
                        </ul>
                    </div>
                </div>
                <div class="OrgChartOutput-bottombox">
                    <div class="OrgChartOutput-optionLine">
                        <span class="optionLine-title">{{ $t("OrgChartOutput.include") }}:</span>
                        <Checkbox v-model="layout" style="margin-right: 65px">{{ $t("OrgChartOutput.layout") }}</Checkbox>
                        <Checkbox v-model="level">{{ $t("OrgChartOutput.level") }}</Checkbox>
                    </div>
                    <div class="OrgChartOutput-optionLine">
                        <span class="optionLine-title">{{ $t("OrgChartOutput.output") }}:</span>
                        <RadioGroup v-model="outputType">
                            <Radio label="allTable" style="margin-right: 60px">
                                <span>{{ $t("OrgChartOutput.allTable") }}</span>
                            </Radio>
                            <Radio label="allBranch" style="margin-right: 60px" :disabled="mulSelect">
                                <span>{{ $t("OrgChartOutput.allBranch") }}</span>
                            </Radio>
                            <Radio label="selectShape" :disabled="mulSelect">
                                <span>{{ $t("OrgChartOutput.selectShape") }}</span>
                            </Radio>
                        </RadioGroup>
                    </div>
                </div>
            </div>
            <div class="dialog-btnbox-normal">
                <div class="dialog-btn-ok" @click="confirm()">{{ $t("OrgChartOutput.confirm") }}</div>
                <div class="" @click="closeModal()">{{ $t("OrgChartOutput.cancel") }}</div>
            </div>
        </Dialog>
    </div>
</template>

<script lang="ts">
    import { Component, Prop, Vue, Watch } from "vue-property-decorator";
    import Dialog from "./Dialog.vue";

    // @Component 修饰符注明了此类为一个 Vue 组件
    @Component({
        components: {
            Dialog,
        },
    })
    export default class OrgChartOutput extends Vue {
        layout: boolean = false;
        level: boolean = true;
        outputType: string = "allTable";

        leftID: number = -1;
        rightID: number = -1;
        leftFlag: boolean = false;
        rightFlag: boolean = false;
        leftList: Array<object> = [
            {
                id: 0,
                name: "123",
            },
            {
                id: 1,
                name: "123",
            },
            {
                id: 2,
                name: "123",
            },
            {
                id: 3,
                name: "123",
            },
        ];
        rightList: Array<object> = [];

        selectLeft(id) {
            this.leftID = id;
        }
        selectRight(id) {
            this.rightID = id;
        }
        addToRight() {
            if (this.leftFlag) {
                return;
            }
            this.leftFlag = true;
            setTimeout(() => {
                let num = -1;
                for (let i = 0; i < this.leftList.length; i++) {
                    if (this.leftList[i]["id"] == this.leftID) {
                        num = i;
                    }
                }
                if (num == -1) {
                    this.leftFlag = false;
                    return;
                } else {
                    let temp = this.leftList.splice(num, 1)[0];
                    this.rightList.push(temp);
                }
                this.leftFlag = false;
            }, 100);
        }
        addToLeft() {
            if (this.rightFlag) {
                return;
            }
            this.rightFlag = true;
            setTimeout(() => {
                let num = -1;
                for (let i = 0; i < this.rightList.length; i++) {
                    if (this.rightList[i]["id"] == this.rightID) {
                        num = i;
                    }
                }
                if (num == -1) {
                    this.rightFlag = false;
                    return;
                } else {
                    let temp = this.rightList.splice(num, 1)[0];
                    this.leftList.push(temp);
                }
                this.rightFlag = false;
            }, 100);
        }
        allRight() {
            this.leftList = null;
            this.rightList = null;
            this.leftList = [];
            this.rightList = JSON.parse(JSON.stringify(this.baseData));
        }
        allLeft() {
            this.leftList = null;
            this.rightList = null;
            this.rightList = [];
            this.leftList = JSON.parse(JSON.stringify(this.baseData));
        }

        confirm() {
            console.log(this.rightList); // 右侧导出项
            console.log(this.layout); // 布局信息
            console.log(this.level); // 层级关系
            console.log(this.outputType); // 导出范围
            window["_view"]._orgUITool.orgExportToExcel("xlsx", this.outputType, this.layout, this.level, this.rightList);
            this.closeModal();
        }
        closeModal() {
            this.$store.commit("setDialogState", {
                type: "showDialog",
                data: false,
            });
        }
        get baseData() {
            return this.$store.state.orgchart.tableList.map((v, k) => {
                v["id"] = k;
                return v;
            });
        }
        @Watch("baseData")
        onBaseDataChange(newval: any, oldVal: any) {
            if (newval) {
                this.leftList = null;
                this.rightList = null;
                this.leftList = newval;
                this.rightList = [];
            }
        }

        get mulSelect() {
            return this.$store.state.orgchart.mulSelect;
        }

        mounted() {
            this.leftList = JSON.parse(JSON.stringify(this.baseData));
        }

        created() {}
    }
</script>
<i18n>
{
  "zh": {
    "OrgChartOutput": {
      "title": "导出组织图",
      "canOutputObject": "可导出项",
      "addToRight": "添加",
      "addToLeft": "移除",
      "allRight": "全部添加",
      "allLeft": "全部移除",
      "outputObject": "导出选项",
      "include": "包括",
      "layout": "布局信息",
      "level": "层级关系",
      "output": "导出",
      "allTable": "整个图表",
      "allBranch": "整个分支",
      "selectShape": "所选形状",
      "confirm": "导出",
      "cancel": "取消"
    }
  },
  "en": {
    "OrgChartOutput": {
      "title": "Export Wizard",
      "canOutputObject": "Available Items",
      "addToRight": "Add",
      "addToLeft": "Remove",
      "allRight": "Add all",
      "allLeft": "Remove all",
      "outputObject": "Export Options",
      "include": "Include",
      "layout": "Layout",
      "level": "Relationship",
      "output": "Export",
      "allTable": "Entire Chart",
      "allBranch": "Entire Branch",
      "selectShape": "Selected Shapes",
      "confirm": "Export",
      "cancel": "Cancel"
    }
  },
  "fr": {
    "OrgChartOutput": {
      "title": "Assistant d'exportation",
      "canOutputObject": "Articles Exportables",
      "addToRight": "Ajouter",
      "addToLeft": "Supprimer",
      "allRight": "Tout Ajouter",
      "allLeft": "Tout Supprimer",
      "outputObject": "Options d'exportation",
      "include": "Comprendre",
      "layout": "Disposition",
      "level": "Relationship",
      "output": "Exporter",
      "allTable": "Graphique Entier",
      "allBranch": "Branche Entière",
      "selectShape": "Formes Sélectionnées",
      "confirm": "Exporter",
      "cancel": "Supprimer"
    }
  },
  "de": {
    "OrgChartOutput": {
      "title": "Organigramm exportieren",
      "canOutputObject": "Exportierbarer Artikel",
      "addToRight": "Hinzufügen",
      "addToLeft": "Entfernen",
      "allRight": "Alle hinzufügen",
      "allLeft": "Alle entfernen",
      "outputObject": "Optionen exportieren",
      "include": "Beinhalten",
      "layout": "Layout",
      "level": "Verhältnis",
      "output": "Exportieren",
      "allTable": "Ganze Tabelle ",
      "allBranch": "Ganze Branche",
      "selectShape": "Ausgewählte Formen",
      "confirm": "Exportieren",
      "cancel": "Abbrechen"
    }
  },
  "jp": {
    "OrgChartOutput": {
      "title": "エクスポートウィザード",
      "canOutputObject": "エクスポート可能なもの",
      "addToRight": "追加",
      "addToLeft": "削除",
      "allRight": "すべて追加",
      "allLeft": "すべて削除",
      "outputObject": "エクスポートオプション",
      "include": "以下を含む",
      "layout": "レイアウト情報",
      "level": "関係",
      "output": "エクスポート",
      "allTable": "組織図全体",
      "allBranch": "ブランチ全体",
      "selectShape": "選択中の図形",
      "confirm": "エクスポート",
      "cancel": "キャンセル"
    }
  },
  "es": {
    "OrgChartOutput": {
      "title": "Mago de la Exportación",
      "canOutputObject": "Artículos disponibles",
      "addToRight": "Añadir",
      "addToLeft": "Remover",
      "allRight": "Añadir todo",
      "allLeft": "Quitar todo",
      "outputObject": "Opciones de exportación",
      "include": "Incluir",
      "layout": "Diseño",
      "level": "Relación",
      "output": "Exportación",
      "allTable": "Tabla entera",
      "allBranch": "Rama entera",
      "selectShape": "Selected Shapes",
      "confirm": "Exportar",
      "cancel": "Cancelar"
    }
  },
  "pt": {
    "OrgChartOutput": {
      "title": "Exportar Wizard",
      "canOutputObject": "Itens Disponíveis",
      "addToRight": "Adicionar",
      "addToLeft": "Remover",
      "allRight": "Adicionar todos",
      "allLeft": "Remover todos",
      "outputObject": "Exportar Opções",
      "include": "Incluir",
      "layout": "Layout",
      "level": "Relação",
      "output": "Exportar",
      "allTable": "Gráfico Completo",
      "allBranch": "Ramo Completo",
      "selectShape": "Formas Selecionadas",
      "confirm": "Exportar",
      "cancel": "Cancelar"
    }
  },
  "it": {
    "OrgChartOutput": {
      "title": "Guida all'Esportazione",
      "canOutputObject": "Elementi Disponibili",
      "addToRight": "Aggiungi",
      "addToLeft": "Rimuovi",
      "allRight": "Aggiungi Tutti",
      "allLeft": "Rimuovi Tutti",
      "outputObject": "Opzioni di Esportazione",
      "include": "Includi",
      "layout": "Layout",
      "level": "Relazioni",
      "output": "Esporta",
      "allTable": "Tutto il Diagramma",
      "allBranch": "Tutto il Ramo",
      "selectShape": "Forme Selezionate",
      "confirm": "Esporta",
      "cancel": "Annulla"
    }
  },
  "tw": {
    "OrgChartOutput": {
      "title": "導出組織圖",
      "canOutputObject": "可導出項",
      "addToRight": "添加",
      "addToLeft": "移除",
      "allRight": "全部添加",
      "allLeft": "全部移除",
      "outputObject": "導出選項",
      "include": "包括",
      "layout": "佈局信息",
      "level": "層級關係",
      "output": "導出",
      "allTable": "整個圖表",
      "allBranch": "整個分支",
      "selectShape": "所選形狀",
      "confirm": "導出",
      "cancel": "取消"
    }
  },
  "kr": {
    "OrgChartOutput": {
      "title": "조직도 내보내기",
      "canOutputObject": "내보내기 가능 항목",
      "addToRight": "추가",
      "addToLeft": "삭제",
      "allRight": "모두 추가",
      "allLeft": "모두 삭제",
      "outputObject": "옵션 내보내기",
      "include": "포함",
      "layout": "레이아웃 정보",
      "level": "층간관계",
      "output": "내보내기",
      "allTable": "전체 도표",
      "allBranch": "전체 분과",
      "selectShape": "선택한 모양",
      "confirm": "내보내기",
      "cancel": "취소 "
    }
  }
}
</i18n>
